// extracted by mini-css-extract-plugin
module.exports = {"UserPic":"style_UserPic__WhMLs","UserInitials":"style_UserInitials__Sc9VA"};